import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Card, Chip, Box, Container, CircularProgress, Typography, Alert } from '@mui/material';
import { Dashboard as AppstoreOutlined, CalendarMonth as CalendarOutlined, Shield as ShieldOutlined } from '@mui/icons-material';
import ListaServicios from '../../components/servicios/serviciosMedico';
import DisponibilidadMedico from '../../components/agendaMedico/agendaMedico';
import CoberturaPacientes from '../../components/cobertura/CoberturaPacientes';
import AuthService from '../../service/authService';
import MedicoService from '../../service/medicoService';
import './medicoConfigPage.css';

const mapearServiciosDelMedico = (medico) => {
  if (!medico) return [];
  const especialidades = (medico.especialidades || []).map(e => ({
    ...e,
    tipo: 'ESPECIALIDAD'
  }));
  const practicas = (medico.practicas || []).map(p => ({
    ...p,
    tipo: 'PRACTICA'
  }));
  return [...especialidades, ...practicas];
};

const MedicoConfigPage = () => {
  const [medico, setMedico] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [todosMisServicios, setTodosMisServicios] = useState([]);


 useEffect(() => {
    const cargarDatosMedico = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log("1. Intentando llamar a AuthService.obtenerPerfil()...");

        const perfilCompleto = await AuthService.obtenerPerfil();

        console.log("2. Perfil completo recibido:", perfilCompleto);

        let medicoData = null;

        if (perfilCompleto.medicoId) {

          medicoData = {
            ...perfilCompleto.medicoId,

            id: perfilCompleto.medicoId._id,
            _id: perfilCompleto.medicoId._id
          };
        } else if (perfilCompleto._id) {

          medicoData = {
            ...perfilCompleto,
            id: perfilCompleto._id
          };
        } else {

          medicoData = perfilCompleto;

          if (medicoData.id && !medicoData._id) {
            medicoData._id = medicoData.id;
          }
        }

        console.log("3. Datos del médico normalizados:", medicoData);
        console.log("4. ID del médico que se usará:", medicoData?.id || medicoData?._id);


        setMedico(medicoData);
      } catch (err) {
        console.error("5. ERROR:", err);
        setError(err.message || "No se pudo obtener la información del profesional.");
      } finally {
        setLoading(false);
      }
    };

    cargarDatosMedico();
  }, []);



  useEffect(() => {
    if (medico) {
      const servicios = mapearServiciosDelMedico(medico);
      setTodosMisServicios(servicios);
    }
  }, [medico]);


  const handleUpdateMedico = (nuevoMedico) => {
    setMedico(nuevoMedico);
  };


  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };


  if (loading) {
    return (
      <div className="loading-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
        <CircularProgress />
      </div>
    );
  }


  if (error) {
    return (
      <Container maxWidth="xl" className="medico-config-page" style={{ paddingTop: '24px' }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }


  return (
    <Container maxWidth="xl" className="medico-config-page">
      <Card className="medico-profile-card">
        <div>
          <Typography variant="h4" className="profile-name">
            {medico?.nombre}
          </Typography>
          <div className="profile-tags">
            <Chip
              label={`Matrícula: ${medico?.matricula}`}
              className="profile-chip"
            />
          </div>
          <Typography variant="body2" className="sedes-text">
            <strong>Sedes vinculadas:</strong>{' '}
            {medico?.sedes?.map(s => s.nombre).join(', ') || 'Ninguna asignada'}
          </Typography>
        </div>
      </Card>


      <Card className="tabs-container">
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          className="medico-tabs"
        >
          <Tab
            icon={<AppstoreOutlined />}
            iconPosition="start"
            label="Prácticas y Especialidades"
          />
          <Tab
            icon={<CalendarOutlined />}
            iconPosition="start"
            label="Agenda y Disponibilidad"
          />

          <Tab
            icon={<ShieldOutlined />}
            iconPosition="start"
            label="Cobertura de Pacientes"
          />

        </Tabs>
        <div className="tab-content">
          {activeTab === 0 && (
            <ListaServicios
              medico={medico}
              onUpdateMedico={handleUpdateMedico}
            />
          )}
          {activeTab === 1 && (
            <DisponibilidadMedico
              medico={medico}
              onUpdateMedico={handleUpdateMedico}
            />
          )}

          {activeTab === 2 && (
            <CoberturaPacientes
              medico={medico}
              medicoServicios={todosMisServicios}
            />
          )}

        </div>
      </Card>
    </Container>
  );
};


export default MedicoConfigPage;